import { render, staticRenderFns } from "./UkStep1.vue?vue&type=template&id=5af73339"
import script from "./UkStep1.vue?vue&type=script&lang=js"
export * from "./UkStep1.vue?vue&type=script&lang=js"
import style0 from "./UkStep1.vue?vue&type=style&index=0&id=5af73339&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports